<script>
export default {
    provide() {
        return {
            iconSource: icon => {
                if(typeof icon == 'string' && icon.indexOf('.') === -1) {
                    const iconParts = icon.split('_');

                    if(iconParts.length == 2) {
                        const type = iconParts[0];
                        const category = iconParts[1];

                        if(type == 'door') {
                            switch(category) {
                                case 'common': return this.icon('door.svg');
                            }
                        }
                    }
                }

                switch(icon) {
                    case 1: icon = 'lock.svg';
                        break;
                    case 2: icon = 'shiftable.svg';
                        break;
                    case 3: icon = 'span.svg';
                        break;
                    case 'duration': icon = 'clock.svg';
                        break;
                }

                return this.icon(icon);
            }
        };
    }
}
</script>